<ng-container *appI18nScopeReady>
  @if (views().length === 0 && !loading()) {
    <app-empty-state-card
      [title]="'no_custom_view_created' | i18n"
      [hint]="canEdit() ? ('no_custom_views_hint' | i18n) : null"
    >
      @if (canEdit()) {
        <button mat-flat-button type="button" (click)="createView()">
          <mat-icon>add</mat-icon>
          {{ 'create_custom_view_btn' | i18n }}
        </button>
      }
    </app-empty-state-card>
  }
</ng-container>
